import React, { createContext, useCallback, useContext, useState } from "react";

interface LogoutContextValue {
  isLoggingOut: boolean;
  startLogout: () => void;
}

const LogoutContext = createContext<LogoutContextValue>({
  isLoggingOut: false,
  startLogout: () => {},
});

export const LogoutProvider = ({ children }: { children: React.ReactNode }) => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const startLogout = useCallback(() => setIsLoggingOut(true), []);

  return (
    <LogoutContext.Provider value={{ isLoggingOut, startLogout }}>
      {children}
    </LogoutContext.Provider>
  );
};

export const useLogoutState = () => useContext(LogoutContext);
